/**
 * Bucket picker. "auto" sends no bucket (the server picks, contract §1.3)
 * and the label shows what the server actually used — `meta.bucket_secs`
 * of the latest bucketed response, published through `useUi.serverBucket`
 * by the API client — as "auto → 4h". Before any response has arrived the
 * label falls back to the local mirror of the server rule.
 */
import { BUCKETS } from "@/api/types";
import { autoBucket, bucketLabel } from "@/lib/bucket";
import { useUi } from "@/state/ui";
import { useUrlState } from "@/state/useUrlState";

export function BucketPicker() {
  const { state, range, setBucket } = useUrlState();
  const serverBucket = useUi((s) => s.serverBucket);
  const resolved = serverBucket ?? autoBucket(range.from, range.to);
  const explicit = state.bucket !== undefined;
  const title = explicit
    ? `bucket size (explicit ${bucketLabel(state.bucket)})`
    : serverBucket
      ? `bucket size: auto, the server chose ${bucketLabel(serverBucket)}`
      : `bucket size: auto (expected ${bucketLabel(resolved)})`;
  return (
    <select
      className="ctl shrink-0"
      value={explicit ? state.bucket : "auto"}
      onChange={(e) => setBucket(e.target.value === "auto" ? undefined : Number(e.target.value))}
      title={title}
      aria-label="bucket size"
    >
      <option value="auto">auto → {bucketLabel(resolved)}</option>
      {BUCKETS.map((b) => (
        <option key={b} value={b}>
          {bucketLabel(b)}
        </option>
      ))}
    </select>
  );
}
